import React from 'react';
import ReactDOM from 'react-dom/client';
// antd v5 global reset (box-sizing: border-box etc.) — the layout was authored against
// antd v4's bundled reset, removed in the v5 migration; same import web/main.tsx uses.
import 'antd/dist/reset.css';
import './index.less';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
// @ts-ignore
import { PersistGate } from 'redux-persist/integration/react';
import packageJson from '../package.json';
import reportWebVitals from './reportWebVitals';
import { store, persistor } from './redux/config';
import AppRoute from './routes/AppRoute';
import { Data, Setup } from './init/index';
import LoadingContainer from './ui/components/LoadingScreen/LoadingContainer';
import Notification from './ui/components/Notification/Notification';
import Dialog from './ui/components/Dialog/Dialog';
import StatusIndicator from './ui/components/StatusIndicator/StatusIndicator';
import ErrorBoundary from './ui/components/ErrorBoundary/ErrorBoundary';

Sentry.init({
  dsn: process.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0.2,
  release: packageJson.version,
  environment:
    process.env.VITE_STAGE === 'production' ? 'production' : 'staging',
});

let root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<LoadingContainer />} persistor={persistor}>
        <ErrorBoundary>
          <Setup>
            <Data>
              <>
                <StatusIndicator />
                <Dialog />
                <Notification />
                <AppRoute />
              </>
            </Data>
          </Setup>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
